<script async setup lang="ts">
import { removeCidFromCartLocalStorage } from '@/store/cart.store'
import { XMarkIcon } from '@heroicons/vue/16/solid'

const props = defineProps<{
  cid: number
}>()
</script>
<template>
  <div @click.prevent.stop="removeCidFromCartLocalStorage(props.cid)" class="w-6">
    <XMarkIcon class="cursor-pointer transition-colors" />
  </div>
</template>
